import wretch from 'wretch'
import QueryStringAddon from 'wretch/addons/queryString'
import AbortAddon from 'wretch/addons/abort'
import type { APIResponse } from '../types/utils'

/* DOCS
    github: https://github.com/elbywan/wretch
    API: https://elbywan.github.io/wretch/api/
*/
const fetcher = wretch()
  .addon(QueryStringAddon)
  .addon(AbortAddon())
  .errorType('json')

export default fetcher

export function mockFetcher<T>(
  returnData: T,
  options = { success: true, timeout: 300 }
): Promise<APIResponse<T>> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (options.success) {
        resolve({ data: returnData, message: 'Success', success: true })
      } else {
        reject(new Error('Failed to fetch data'))
      }
    }, options.timeout)
  })
}

const BasePath = import.meta.env.VITE_API_BOOKING

export const API_ENDPOINT = {
  getProperty: `${BasePath}property`,
} as const
